import { FEATURE_FLAGS, useConfigMatch } from 'modules/taboola-common-frontend-modules/account-configurations';
import { useFormFieldValue } from 'modules/taboola-common-frontend-modules/formData';

export const useCpaGoalFormFieldValue = () => {
    const isPermitted = useConfigMatch({ [FEATURE_FLAGS.TARGET_CPA_ENABLED]: 'false' });
    const props = useFormFieldValue({ field: 'cpaGoal', isPermitted });

    return { ...props, isPermitted };
};
